function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.122,6.26266667 L13.8686667,6.10333333 C13.7653333,5.78533333 13.638,5.47866667 13.4893333,5.18733333 L14.2633333,4.19066667 C14.5766667,3.78733333 14.54,3.218 14.182,2.87133333 L13.132,1.82133333 C12.782,1.46 12.2126667,1.424 11.8086667,1.73666667 L10.8133333,2.51066667 C10.522,2.362 10.2153333,2.23466667 9.89666667,2.13133333 L9.73733333,0.88 C9.67733333,0.378 9.25133333,0 8.74666667,0 L7.25333333,0 C6.74866667,0 6.32266667,0.378 6.26266667,0.878 L6.10333333,2.13133333 C5.78466667,2.23466667 5.478,2.36133333 5.18666667,2.51066667 L4.19066667,1.73666667 C3.788,1.424 3.21866667,1.46 2.87133333,1.818 L1.82133333,2.86733333 C1.46,3.218 1.42333333,3.78733333 1.73666667,4.19133333 L2.51066667,5.18733333 C2.36133333,5.47866667 2.23466667,5.78533333 2.13133333,6.10333333 L0.88,6.26266667 C0.378,6.32266667 5.32907052e-14,6.74866667 5.32907052e-14,7.25333333 L5.32907052e-14,8.74666667 C5.32907052e-14,9.25133333 0.378,9.67733333 0.878,9.73733333 L2.13133333,9.89666667 C2.23466667,10.2146667 2.362,10.5213333 2.51066667,10.8126667 L1.73666667,11.8093333 C1.42333333,12.2126667 1.46,12.782 1.818,13.1286667 L2.868,14.1786667 C3.21866667,14.5393333 3.78733333,14.5753333 4.19133333,14.2626667 L5.18733333,13.4886667 C5.47866667,13.638 5.78533333,13.7653333 6.10333333,13.868 L6.26266667,15.1186667 C6.32266667,15.622 6.74866667,16 7.25333333,16 L8.74666667,16 C9.25133333,16 9.67733333,15.622 9.73733333,15.122 L9.89666667,13.8686667 C10.2146667,13.7653333 10.5213333,13.638 10.8126667,13.4893333 L11.8093333,14.2633333 C12.2126667,14.5766667 12.782,14.54 13.1286667,14.182 L14.1786667,13.132 C14.54,12.7813333 14.5766667,12.2126667 14.2633333,11.8086667 L13.4893333,10.8126667 C13.6386667,10.5213333 13.766,10.2146667 13.8686667,9.89666667 L15.1193333,9.73733333 C15.6213333,9.67733333 15.9993342,9.25133333 15.9993342,8.74666667 L15.9993342,7.25333333 C16,6.74866667 15.622,6.32266667 15.122,6.26266667 Z M8,11.3333333 C6.162,11.3333333 4.66666667,9.838 4.66666667,8 C4.66666667,6.162 6.162,4.66666667 8,4.66666667 C9.838,4.66666667 11.3333333,6.162 11.3333333,8 C11.3333333,9.838 9.838,11.3333333 8,11.3333333 Z",
  id: "icon_menu_settings_active-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Settings",
  transform: "translate(0.000000, -0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_menu_settings_active",
  transform: "translate(0.000000, -0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon_menu_settings_active-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon_menu_settings_active-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#595959",
  fillRule: "nonzero",
  xlinkHref: "#icon_menu_settings_active-path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "UI-Color-/-Active-Color-",
  mask: "url(#icon_menu_settings_active-mask-2)",
  fill: "#202020"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16 0 16 16 0 16"
})))));

function SvgIconMenuSettingsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuSettingsActive);
export default __webpack_public_path__ + "static/media/icon_menu_settings_active.102e3430.svg";
export { ForwardRef as ReactComponent };